module.exports = __webpack_public_path__ + "static/media/leading.f7df05c1.png";